import type * as Types from 'app/types/graphql';

import {
  CollectionEdgeSelectFragmentDoc,
  CollectionSelectFragmentDoc,
} from '../fragments/collections.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type CollectionsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.CollectionOrder>;
  where?: Types.InputMaybe<Types.CollectionWhereInput>;
}>;

export type CollectionsQueryResponse = {
  collections?: Types.Maybe<{
    edges: Array<{
      node?: Types.Maybe<
        Pick<Types.Collection, 'baseID' | 'title' | 'handle' | 'publishedAt' | 'templateSuffix'> & {
          collectionMedia?: Types.Maybe<Pick<Types.CollectionMedia, 'src'>>;
        }
      >;
    }>;
    pageInfo?: Types.Maybe<Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>>;
  }>;
};

export const CollectionsDocument = `
    query Collections($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: CollectionOrder, $where: CollectionWhereInput) {
  collections(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    where: $where
  ) {
    edges {
      ...CollectionEdgeSelect
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CollectionEdgeSelectFragmentDoc}
${CollectionSelectFragmentDoc}`;

export const useCollectionsQuery = <TData = CollectionsQueryResponse, TError = unknown>(
  variables?: CollectionsQueryVariables,
  options?: UseQueryOptions<CollectionsQueryResponse, TError, TData>,
) => {
  return useQuery<CollectionsQueryResponse, TError, TData>(
    variables === undefined ? ['Collections'] : ['Collections', variables],
    appFetcher<CollectionsQueryResponse, CollectionsQueryVariables>(CollectionsDocument, variables),
    options,
  );
};

useCollectionsQuery.getKey = (variables?: CollectionsQueryVariables) =>
  variables === undefined ? ['Collections'] : ['Collections', variables];
